/**
 * 매뉴얼 문구 — `landing` 네임스페이스의 `site.manual` 로 합쳐진다(service-manual: 매뉴얼 문구의 출처).
 * 꾸밈: `<ui>…</ui>` 화면의 단추·칸 이름, `<a href="#t-…">…</a>` 다른 절로 가는 링크. 절 구조·안내 화면 좌표는
 * `Home/Manual/manualTopics.ts`·`manualGuides.ts` 에 있다.
 */
const landingManual = {
  "eyebrow": "매뉴얼",
  "title": "영상 따라 익히는 드론스퀘어",
  "searchLabel": "매뉴얼 검색",
  "searchPlaceholder": "찾고 싶은 기능을 입력하세요 (예: 매핑, 횡단면)",
  "searchEmpty": "찾는 기능이 없습니다. 다른 단어로 찾아보세요.",
  "searchCount": "{{count}}개 절을 찾았습니다.",
  "chaptersLabel": "기능별 안내",
  "jumpLabel": "매뉴얼 장 바로가기",
  "tocLabel": "{{chapter}} 절 목록",
  "allChapters": "전체 목차",
  "backToStart": "처음으로",
  "gate": {
    "title": "매뉴얼, 시연 영상은 로그인 후 볼 수 있어요",
    "text": "드론스퀘어 계정으로 로그인하거나, 계정이 없으면 1:1 문의로 알려 주세요.",
    "login": "로그인",
    "inquiry": "1:1 문의하기"
  },
  "noteLabel": {
    "note": "참고",
    "caution": "주의"
  },
  "player": {
    "label": "단계별 안내: {{title}}",
    "stepsLabel": "단계로 이동",
    "step": "{{n}}단계: {{title}}",
    "prev": "이전 단계: {{title}}",
    "next": "다음 단계: {{title}}",
    "play": "재생",
    "pause": "일시정지"
  },
  "chapters": {
    "c1": {
      "name": "프로젝트",
      "subtitle": "프로젝트와 촬영일 관리"
    },
    "c2": {
      "name": "이미지·매핑",
      "subtitle": "사진을 올리고 지도로 만들기"
    },
    "c3": {
      "name": "참고·레이어 데이터",
      "subtitle": "도면과 자료를 함께 올리기"
    },
    "c4": {
      "name": "2D 점검",
      "subtitle": "정사영상으로 현장 점검하기",
      "open": "2D 점검은 처리가 끝난 촬영일의 하위 표 메뉴에서 <ui>시계열 점검</ui>을 누르거나, 왼쪽 레일의 <ui>2d3d</ui>를 누르면 열립니다."
    },
    "c5": {
      "name": "3D 점검",
      "subtitle": "3D 모델로 현장 점검하기",
      "open": "3D 점검은 레일의 <ui>3D</ui>를 누르면 같은 촬영일의 3D 모델로 열립니다. 3D가 아직 만들어지지 않았으면 「3D(mesh)는 아직 구축되지 않았습니다」가 뜹니다."
    },
    "c6": {
      "name": "단면 그래프",
      "subtitle": "종단면과 횡단면 보기"
    },
    "c7": {
      "name": "작업현황 관제",
      "subtitle": "작업자와 장비를 지도에서 관제하기",
      "open": "작업현황 관제는 프로젝트 목록의 레일 <ui>worksite</ui>로 들어갑니다. 2D나 3D 중 하나라도 처리가 끝난 촬영일이 있어야 열립니다."
    },
    "c8": {
      "name": "토공",
      "subtitle": "구역과 선형으로 토공량 내기",
      "open": "토공은 프로젝트에 단지 도면이나 선형 레이어가 있고 처리가 끝난 촬영일이 있으면, 레일 <ui>earthwork</ui>로 들어갑니다."
    }
  },
  "topics": {
    "t-new": {
      "title": "새 프로젝트 만들기",
      "note": "목록 「필터」는 태그로만 거릅니다. 나중에 묶어서 찾을 기준은 태그로 붙여 두세요. 창을 닫으면 입력한 내용은 지워집니다. 위치·이름·타입·태그·메모는 만든 뒤에도 <a href=\"#t-edit\">프로젝트 정보 수정</a>에서 바꿀 수 있습니다.",
      "steps": [
        {
          "title": "「새 프로젝트 생성」 누르기",
          "caption": "오른쪽 위 「새 프로젝트 생성」을 누릅니다."
        },
        {
          "title": "위치 단계 시작하기",
          "caption": "「프로젝트 추가」 창이 열립니다. 1단계 위치: 주소를 검색하거나 지도를 누릅니다."
        },
        {
          "title": "현장 주소 고르기",
          "caption": "검색 결과가 뜨면 현장 주소를 고릅니다."
        },
        {
          "title": "위치 확인하고 「다음」",
          "caption": "지도가 그 위치로 움직이고 아래 카드에 주소와 위도·경도가 뜹니다. 「다음」을 누릅니다."
        },
        {
          "title": "프로젝트 정보 입력하기",
          "caption": "2단계 프로젝트 정보: 프로젝트명, 인프라 타입, 객체 타입, 태그, 메모를 넣습니다."
        },
        {
          "title": "「인프라 타입」 열기",
          "caption": "프로젝트명을 넣었습니다. 「인프라 타입」을 고릅니다."
        },
        {
          "title": "객체 종류 고르기",
          "caption": "일반·코리더·면·수직 객체 중에서 고릅니다. 「기타」는 직접 입력합니다."
        },
        {
          "title": "「객체 타입」 넣기",
          "caption": "「객체 타입」을 넣습니다."
        },
        {
          "title": "태그·메모 적고 「다음」",
          "caption": "태그·메모는 선택입니다. 「다음」을 누릅니다."
        },
        {
          "title": "촬영일 칸 열기",
          "caption": "3단계 시계열 추가: 촬영일 칸을 눌러 첫 촬영일을 고릅니다."
        },
        {
          "title": "달력에서 날짜 고르기",
          "caption": "달력에서 날짜를 고릅니다."
        },
        {
          "title": "「추가」로 만들기",
          "caption": "촬영일이 채워졌습니다. 「추가」를 누르면 프로젝트가 만들어집니다."
        },
        {
          "title": "생성 완료 확인",
          "caption": "「프로젝트 생성 성공」 알림이 뜨고 목록으로 돌아갑니다."
        }
      ]
    },
    "t-edit": {
      "title": "프로젝트 정보 수정",
      "note": "촬영일과 촬영일 메모는 이 창이 아니라 <a href=\"#t-series\">시계열 추가·수정·삭제</a>에서 고칩니다.",
      "steps": [
        {
          "title": "프로젝트 고르기",
          "caption": "목록에서 고칠 프로젝트를 누릅니다."
        },
        {
          "title": "「수정」 누르기",
          "caption": "오른쪽 「정보」 탭 「세부 정보」 옆 「수정」을 누릅니다."
        },
        {
          "title": "고칠 칸 고치기",
          "caption": "「프로젝트 정보 수정」 창이 열립니다. 이름·타입·태그·메모 중 고칠 칸을 고칩니다."
        },
        {
          "title": "「저장」 누르기",
          "caption": "고친 뒤 「저장」을 누릅니다. 「초기화」는 처음 값으로 되돌립니다."
        },
        {
          "title": "수정 완료 확인",
          "caption": "「프로젝트 정보가 수정되었습니다」 알림이 뜨고 세부 정보에 바로 반영됩니다."
        }
      ]
    },
    "t-series": {
      "title": "시계열 추가·수정·삭제",
      "note": "촬영일 추가·수정은 프로젝트 소유자만 할 수 있습니다.",
      "steps": [
        {
          "title": "「시계열 추가」 누르기",
          "caption": "표의 「시계열 추가」를 누릅니다."
        },
        {
          "title": "촬영일 칸 열기",
          "caption": "「시계열 추가」 창입니다. 촬영일 칸을 눌러 날짜를 고릅니다."
        },
        {
          "title": "달력에서 촬영일 고르기",
          "caption": "달력에서 촬영일을 고릅니다. 이미 있는 날짜는 만들 수 없습니다."
        },
        {
          "title": "메모 넣기",
          "caption": "촬영일이 들어갔습니다. 메모 칸에 이 회차의 설명을 적습니다."
        },
        {
          "title": "「완료」 누르기",
          "caption": "메모를 넣고 「완료」를 누릅니다."
        },
        {
          "title": "촬영일 목록 펼치기",
          "caption": "새 촬영일이 더해졌습니다. 프로젝트 줄 왼쪽 화살표를 누르면 촬영일 목록이 펼쳐집니다."
        },
        {
          "title": "고칠 촬영일 고르기",
          "caption": "새 촬영일 줄이 보입니다. 고칠 촬영일을 누릅니다."
        },
        {
          "title": "「수정」 누르기",
          "caption": "오른쪽 「정보」 탭 「$t(projects:timeSeries.mappingInfo)」 옆 「수정」을 누릅니다."
        },
        {
          "title": "메모 고치기",
          "caption": "「시계열 수정」 창에서 촬영일과 메모를 고칩니다."
        },
        {
          "title": "「저장」 누르기",
          "caption": "메모를 고쳤습니다. 「저장」을 누릅니다."
        },
        {
          "title": "휴지통 누르기",
          "caption": "「시계열 정보가 수정되었습니다」 알림이 뜹니다. 지우려면 그 줄의 휴지통을 누릅니다."
        },
        {
          "title": "날짜 똑같이 넣기",
          "caption": "「시계열 삭제」 창입니다. 확인 칸에 그 날짜를 똑같이 넣습니다."
        },
        {
          "title": "「삭제하기」 누르기",
          "caption": "날짜가 같아야 「삭제하기」가 켜집니다. 지운 촬영일은 되돌릴 수 없습니다."
        },
        {
          "title": "삭제 완료 확인",
          "caption": "「삭제에 성공했습니다.」 알림이 뜨고 그 촬영일이 목록에서 빠집니다."
        }
      ]
    },
    "t-list": {
      "title": "프로젝트 목록",
      "note": "「드론 이미지」 탭은 촬영일을 골랐을 때만 보입니다.",
      "steps": [
        {
          "title": "이름으로 검색하기",
          "caption": "로그인하면 프로젝트 목록이 열립니다. 검색 칸에 이름 일부를 넣습니다."
        },
        {
          "title": "검색어 지우기",
          "caption": "잠시 뒤 이름이 맞는 프로젝트만 남습니다. 검색어를 지우면 전체 목록으로 돌아옵니다."
        },
        {
          "title": "「필터」 열기",
          "caption": "전체 목록에서 「필터」를 누르면 태그로 좁혀 볼 수 있습니다."
        },
        {
          "title": "태그 고르기",
          "caption": "찾을 태그에 체크합니다. 옆 숫자는 그 태그가 붙은 프로젝트 수입니다."
        },
        {
          "title": "「적용」 누르기",
          "caption": "「적용」을 누릅니다. 「초기화」는 체크를 모두 풉니다."
        },
        {
          "title": "프로젝트 고르기",
          "caption": "그 태그가 붙은 프로젝트만 표와 지도에 남습니다. 프로젝트를 누릅니다."
        },
        {
          "title": "자료 탭 바꾸기",
          "caption": "지도가 그 위치로 움직이고 아래에 세부 정보 탭이 붙습니다. 「레이어 데이터」 탭을 누릅니다."
        },
        {
          "title": "탭 자료 보기",
          "caption": "탭을 바꿔 가며 그 프로젝트의 자료를 봅니다."
        }
      ]
    },
    "t-member": {
      "title": "멤버와 권한",
      "steps": [
        {
          "title": "프로필 열기",
          "caption": "왼쪽 레일 아래 프로필을 누릅니다."
        },
        {
          "title": "「프로젝트 권한 관리」 열기",
          "caption": "마이페이지가 열립니다. 「프로젝트 권한 관리」를 누릅니다."
        },
        {
          "title": "프로젝트 고르고 「멤버 추가」",
          "caption": "「프로젝트 선택」에서 내가 소유한 프로젝트를 고르면 멤버 목록이 보입니다. 「멤버 추가」를 누릅니다."
        },
        {
          "title": "이메일 넣기",
          "caption": "초대할 사람의 이메일을 넣습니다."
        },
        {
          "title": "「추가」 누르기",
          "caption": "이메일을 넣고 「추가」를 누릅니다."
        },
        {
          "title": "역할 바꾸기",
          "caption": "「사용자가 추가되었습니다」가 뜨고 목록에 새 멤버가 생깁니다. 역할을 고릅니다."
        },
        {
          "title": "「저장」 누르기",
          "caption": "역할을 바꾸면 아래 「저장」이 켜집니다. 「저장」을 눌러야 반영됩니다."
        },
        {
          "title": "저장 완료 확인",
          "caption": "「권한이 수정되었습니다」가 뜹니다."
        }
      ]
    },
    "t-history": {
      "title": "프로젝트 히스토리",
      "note": "목록을 끝까지 내리면 이전 기록을 더 불러옵니다. 시각은 <a href=\"#t-lang\">표시 시간대</a>를 따릅니다.",
      "steps": [
        {
          "title": "프로필 열기",
          "caption": "프로젝트 히스토리는 누가 언제 무엇을 추가·수정·삭제했는지 프로젝트별로 모아 보여 줍니다. 왼쪽 레일 아래 프로필을 누릅니다."
        },
        {
          "title": "「프로젝트 히스토리」 열기",
          "caption": "마이페이지가 열립니다. 「프로젝트 히스토리」를 누릅니다."
        },
        {
          "title": "「필터」 누르기",
          "caption": "「프로젝트 선택」에 고른 프로젝트의 기록이 날짜별 최신순으로 나옵니다. 시계열에서 생긴 기록에는 오른쪽에 촬영일자가 붙습니다. 「필터」를 누릅니다."
        },
        {
          "title": "「어노테이션」 고르기",
          "caption": "기록 종류가 나옵니다. 「어노테이션」을 고릅니다."
        },
        {
          "title": "어노테이션 기록 보기",
          "caption": "어노테이션을 추가·수정·삭제한 기록만 남습니다."
        }
      ]
    },
    "t-lang": {
      "title": "언어와 표시 시간대",
      "note": "고른 언어는 이 브라우저에 저장되어 다음에 열어도 그대로입니다. 표시 시간대는 바꾸는 칸이 없고 브라우저 시간대를 따르며, <a href=\"#t-history\">프로젝트 히스토리</a>의 시각도 이 시간대로 보입니다.",
      "steps": [
        {
          "title": "언어 단추 누르기",
          "caption": "화면 언어는 한국어·영어·일본어·크메르어 중에서 고릅니다. 왼쪽 레일 아래 지금 언어가 적힌 「ko」를 누릅니다."
        },
        {
          "title": "「日本語」 고르기",
          "caption": "네 언어가 나옵니다. 여기서는 「日本語」를 고릅니다."
        },
        {
          "title": "프로필 열기",
          "caption": "메뉴와 단추 글이 일본어로 바뀌고 언어 단추는 「ja」가 됩니다. 표시 시간대를 보러 프로필을 누릅니다."
        },
        {
          "title": "표시 시간대 보기",
          "caption": "마이페이지 계정 정보(「アカウント情報」)의 표시 시간대(「表示タイムゾーン」)가 브라우저 시간대를 따라 자동으로 정해져 있습니다."
        }
      ]
    },
    "t-upload": {
      "title": "드론 이미지 올리기",
      "note": "파일 이름이 같은 사진은 폴더가 달라도 한 장만 올라가니, 여러 비행의 사진은 이름이 겹치지 않게 올리세요.",
      "steps": [
        {
          "title": "「드론 이미지」 탭 열기",
          "caption": "프로젝트와 촬영일을 고르면 아래에 세부 정보가 열립니다. 「드론 이미지」 탭을 누릅니다."
        },
        {
          "title": "「이미지 추가」 누르기",
          "caption": "올린 사진은 「업로드 완료 리스트」에 쌓입니다. 「이미지 추가」를 누릅니다."
        },
        {
          "title": "「파일 선택」으로 사진 고르기",
          "caption": ".jpg·.jpeg 파일을 끌어 놓거나 「파일 선택」으로 고릅니다."
        },
        {
          "title": "「이미지 업로드」 누르기",
          "caption": "업로드 대상 이미지 수와 총 용량이 보입니다. 「이미지 업로드」를 누릅니다."
        },
        {
          "title": "업로드 완료 확인",
          "caption": "「이미지 업로드가 완료되었습니다.」가 뜨고 「업로드 완료 리스트」에 올린 사진이 보입니다."
        }
      ]
    },
    "t-mapping": {
      "title": "매핑 요청과 GCP",
      "steps": [
        {
          "title": "「GCP 업로드」 누르기",
          "caption": "촬영일을 고르고 「정보」 탭의 「$t(projects:timeSeries.mappingInfo)」를 봅니다. 먼저 「GCP 업로드」를 누릅니다."
        },
        {
          "title": "「$t(projects:timeSeries.gcpAutoDetect)」 켜기",
          "caption": "GCP 파일($t(projects:timeSeries.gcpGuide.readableFormats))을 고르면 GCP 줄에 파일 이름이 붙습니다."
        },
        {
          "title": "$t(projects:timeSeries.gcpAutoDetect) 가이드 열기",
          "caption": "표준 표식을 깔고 찍었다면 「$t(projects:timeSeries.gcpAutoDetect)」을 켭니다. 오른쪽 「?」가 $t(projects:timeSeries.gcpAutoDetect) 가이드입니다."
        },
        {
          "title": "가이드 닫기",
          "caption": "「$t(projects:timeSeries.gcpGuide.title)」에서 조건과 표식 인쇄 파일을 확인합니다. 닫기를 누릅니다."
        },
        {
          "title": "「매핑 요청」 누르기",
          "caption": "「매핑 요청」을 누릅니다."
        },
        {
          "title": "「요청」으로 확정",
          "caption": "확인창입니다. 요청한 뒤에는 이미지를 더 올리거나 지울 수 없습니다. 「요청」을 누릅니다."
        },
        {
          "title": "요청 완료 확인",
          "caption": "「매핑 요청이 완료되었습니다.」가 뜨고 버튼이 「요청 완료」로 바뀝니다."
        }
      ]
    },
    "t-download": {
      "title": "결과물 다운로드",
      "note": "높이 값이 필요하면 DSM GeoTIFF 대신 CAD 패키지의 표고점을 쓰세요.",
      "steps": [
        {
          "title": "「생성」 누르기",
          "caption": "처리가 끝난 촬영일의 「$t(projects:timeSeries.mappingInfo)」 오른쪽 「다운로드」 상자입니다. 해상도마다 「생성」 또는 「다운로드」가 있습니다."
        },
        {
          "title": "「다운로드」 누르기",
          "caption": "「생성」을 누르면 「생성 중 N%」가 끝난 뒤 「다운로드」로 바뀝니다."
        },
        {
          "title": "다운로드 확인창 승인",
          "caption": "1 GB가 넘는 큰 파일은 「다운로드 확인」 창을 한 번 더 거칩니다."
        }
      ]
    },
    "t-layerdata": {
      "title": "레이어 데이터",
      "note": "올린 레이어는 2D·3D 화면의 <ui>LAYER</ui> 패널에서 켜고 끕니다.",
      "steps": [
        {
          "title": "「레이어 데이터」 탭 열기",
          "caption": "프로젝트를 고르고 「레이어 데이터」 탭을 누릅니다."
        },
        {
          "title": "업로드 아이콘 누르기",
          "caption": "GIS·선형 Layer·BIM·Point Cloud 상자가 있습니다. 상자 머리의 업로드 아이콘을 누릅니다."
        },
        {
          "title": "업로드 완료 확인",
          "caption": "「파일 업로드가 완료되었습니다.」가 뜨고 GIS 상자에 올린 파일이 생깁니다."
        }
      ]
    },
    "t-terrain": {
      "title": "지형 고도 데이터",
      "note": "횡단 수량표는 원지반고와 계획고가 모두 있어야 볼 수 있습니다.",
      "steps": [
        {
          "title": "「지형 고도 데이터」 탭 열기",
          "caption": "프로젝트를 고르고 「지형 고도 데이터」 탭을 누릅니다."
        },
        {
          "title": "업로드 아이콘 누르기",
          "caption": "「설계도」 상자가 있습니다. 상자 머리의 업로드 아이콘을 누릅니다."
        },
        {
          "title": "정렬 dxf 고르기",
          "caption": "「설계도 업로드」 창에서 도면마다 정렬용 dxf를 짝지어 「업로드」합니다."
        },
        {
          "title": "「업로드」 누르기",
          "caption": "정렬용 dxf 를 고르면 도면 옆에 파일 이름이 붙고 「업로드」가 켜집니다."
        },
        {
          "title": "업로드 완료 확인",
          "caption": "「파일 업로드가 완료되었습니다.」가 뜨고 설계도 상자에 도면이 생깁니다."
        }
      ]
    },
    "t-ref": {
      "title": "참고 데이터",
      "steps": [
        {
          "title": "「참고 데이터」 탭 열기",
          "caption": "프로젝트를 고르고 「참고 데이터」 탭을 누릅니다."
        },
        {
          "title": "문서 업로드 아이콘 누르기",
          "caption": "이미지·문서·비디오 상자가 있습니다. 「문서」 상자 머리의 업로드 아이콘을 누릅니다."
        },
        {
          "title": "업로드 완료 확인",
          "caption": "「파일 업로드가 완료되었습니다.」가 뜨고 문서 상자에 파일이 생깁니다."
        }
      ]
    },
    "t-2dlayer": {
      "title": "레이어 켜고 끄기",
      "note": "GIS·선형 레이어는 <a href=\"#t-layerdata\">레이어 데이터</a>에서 올립니다.",
      "steps": [
        {
          "title": "「LAYER」 열기",
          "caption": "2D 점검 화면 왼쪽 레일의 「LAYER」를 누릅니다."
        },
        {
          "title": "「어노테이션」 끄기",
          "caption": "「LAYER」 패널이 열립니다. 맨 위 「어노테이션」 스위치로 지도의 이슈 표시를 켜고 끕니다."
        },
        {
          "title": "「GIS 레이어」 펼치기",
          "caption": "이슈 표시가 꺼졌습니다. 「GIS 레이어」를 펼칩니다."
        },
        {
          "title": "지적도 켜기",
          "caption": "올린 GIS 레이어가 나옵니다. 지적도 스위치를 켭니다."
        },
        {
          "title": "「선형 레이어」 펼치기",
          "caption": "지적 경계가 지도 위에 겹칩니다. 「선형 레이어」를 펼칩니다."
        },
        {
          "title": "계획 노선 켜기",
          "caption": "계획 노선 스위치를 켭니다."
        },
        {
          "title": "그려진 노선 보기",
          "caption": "계획 노선이 지도 위에 그려집니다."
        },
        {
          "title": "「DSM」 켜기",
          "caption": "「주 레이어」의 「DSM」을 켭니다."
        },
        {
          "title": "고도 색상 보기",
          "caption": "정사영상 대신 DSM 고도 색상이 보입니다. 정사영상과 DSM은 한 번에 하나만 켜집니다."
        }
      ]
    },
    "t-folder": {
      "title": "레이어를 폴더로 묶기",
      "note": "⌘(Windows 는 Ctrl)를 누른 채 누르면 떨어진 레이어도 하나씩 더해 고릅니다. 선형 레이어와 3D 화면의 모델·레이어 목록도 같은 방법으로 묶으며, 폴더를 만들고 옮기는 것은 <a href=\"#t-member\">소유자·편집자</a>만 할 수 있습니다.",
      "steps": [
        {
          "title": "「LAYER」 열기",
          "caption": "GIS 레이어 여러 개를 폴더 하나로 묶으면 목록이 짧아지고 폴더째 켜고 끌 수 있습니다. 2D 점검 화면 왼쪽 레일의 「LAYER」를 누릅니다."
        },
        {
          "title": "「GIS 레이어」 펼치기",
          "caption": "「LAYER」 패널이 열립니다. 「GIS 레이어」를 펼칩니다."
        },
        {
          "title": "새 폴더 단추 누르기",
          "caption": "올린 GIS 레이어가 나옵니다. 검색 칸 옆의 새 폴더 단추를 누릅니다."
        },
        {
          "title": "폴더 이름 넣기",
          "caption": "목록 맨 위에 폴더 이름 칸이 생깁니다. 이름을 넣고 Enter 를 누릅니다."
        },
        {
          "title": "Shift 누른 채 첫 레이어 누르기",
          "caption": "「지하 시설물」 폴더가 생겼습니다. 이제 묶을 레이어를 고릅니다. Shift 를 누른 채 상수관로를 누릅니다."
        },
        {
          "title": "Shift 누른 채 끝 레이어 누르기",
          "caption": "상수관로가 골라지고 목록 위에 고른 개수가 뜹니다. Shift 를 누른 채 가스관로를 누릅니다."
        },
        {
          "title": "폴더로 끌어 놓기",
          "caption": "상수관로부터 가스관로까지 레이어가 모두 골라졌습니다. 그중 하나를 잡아 「지하 시설물」 폴더 위로 끌어다 놓습니다."
        },
        {
          "title": "폴더 펼치기",
          "caption": "골라진 레이어가 함께 폴더 안으로 들어가 목록이 짧아졌습니다. 폴더 앞 화살표를 눌러 펼칩니다."
        },
        {
          "title": "폴더 스위치 켜기",
          "caption": "폴더 안에 관로 레이어가 들어 있습니다. 폴더 줄의 스위치를 켭니다."
        },
        {
          "title": "지도에서 확인",
          "caption": "폴더 안 레이어가 한꺼번에 켜져 관로가 도로를 따라 지도에 그려집니다."
        }
      ]
    },
    "t-compare": {
      "title": "시계열 비교",
      "steps": [
        {
          "title": "「2분할」 누르기",
          "caption": "지도 왼쪽 위 화면 분할 묶음에서 「2분할」을 누릅니다."
        },
        {
          "title": "오른쪽 칸 날짜 열기",
          "caption": "화면이 둘로 나뉩니다. 오른쪽 칸 위 날짜를 누릅니다."
        },
        {
          "title": "비교할 날짜 고르기",
          "caption": "2D 처리가 끝난 촬영일만 나옵니다. 비교할 날짜를 고릅니다."
        },
        {
          "title": "「4분할」 누르기",
          "caption": "같은 자리의 굴착 중과 복구 뒤가 나란히 보입니다. 이번엔 「4분할」을 누릅니다."
        },
        {
          "title": "오른쪽 아래 칸 날짜 열기",
          "caption": "네 칸으로 나뉩니다. 오른쪽 아래 칸의 날짜를 누릅니다."
        },
        {
          "title": "날짜 고르기",
          "caption": "이 칸에서 볼 촬영일을 고릅니다."
        },
        {
          "title": "한 칸 끌어 보기",
          "caption": "칸마다 촬영일을 따로 고릅니다. 한 칸을 끌어 봅니다."
        },
        {
          "title": "함께 움직이는 칸 보기",
          "caption": "모든 칸이 함께 움직입니다."
        }
      ]
    },
    "t-issue": {
      "title": "이슈 만들기와 편집",
      "note": "좌표를 알고 있다면 <ui>ISSUE</ui> → <ui>이슈 생성</ui>에서 위치(x-y 또는 경위도)를 넣어 만들 수도 있습니다.",
      "steps": [
        {
          "title": "「점」 도구 고르기",
          "caption": "그리기 도구 「생성」에서 「점」을 고릅니다."
        },
        {
          "title": "지도에 점 찍기",
          "caption": "커서 옆 안내 칩대로 지도를 클릭합니다."
        },
        {
          "title": "「꼭짓점 수정」 누르기",
          "caption": "「어노테이션 생성 완료」 알림과 함께 바로 이슈로 저장됩니다. 「편집」의 「꼭짓점 수정」을 누릅니다."
        },
        {
          "title": "점 끌어 옮기기",
          "caption": "점을 끌어 옮깁니다."
        },
        {
          "title": "옮긴 자리 확인",
          "caption": "놓은 자리로 바로 저장됩니다."
        }
      ]
    },
    "t-issueinfo": {
      "title": "이슈 찾기와 댓글",
      "steps": [
        {
          "title": "「ISSUE」 열기",
          "caption": "왼쪽 레일의 「ISSUE」를 누릅니다."
        },
        {
          "title": "「필터」 열기",
          "caption": "이슈가 유형별로 묶여 있습니다. 「필터」를 누릅니다."
        },
        {
          "title": "조건 빼기",
          "caption": "처음엔 모든 조건이 켜져 있고, 누른 조건이 빠집니다. 「마커」를 눌러 뺍니다."
        },
        {
          "title": "「확인」 누르기",
          "caption": "「마커」가 빠졌습니다. 「확인」을 누릅니다."
        },
        {
          "title": "유형 머리 펼치기",
          "caption": "조건에 맞는 이슈만 남습니다. 유형 머리를 누르면 그 이슈들이 펼쳐집니다."
        },
        {
          "title": "「이슈로 이동」 누르기",
          "caption": "행의 위치 아이콘(「이슈로 이동」)을 누릅니다."
        },
        {
          "title": "패널 내리기",
          "caption": "지도가 그 이슈로 옮겨 가고 「이슈 정보」가 열립니다. 촬영일별 강도 추이와 정보를 보고 패널을 내립니다."
        },
        {
          "title": "「댓글」 열기",
          "caption": "아래쪽 「댓글 2개」를 누릅니다."
        },
        {
          "title": "댓글 쓰기",
          "caption": "댓글 창입니다. 사진을 붙인 댓글도 여기서 봅니다. 입력칸에 댓글을 씁니다."
        },
        {
          "title": "「전송」 누르기",
          "caption": "「전송」을 누릅니다."
        },
        {
          "title": "달린 댓글 확인",
          "caption": "댓글이 바로 달립니다."
        }
      ]
    },
    "t-measure": {
      "title": "이슈 측정",
      "note": "구역 제목 옆 내려받기 아이콘으로 측정·체적·좌표 값을 CSV 파일로 받습니다.",
      "steps": [
        {
          "title": "면 이슈 누르기",
          "caption": "지도에서 면 이슈를 누릅니다."
        },
        {
          "title": "「측정」 탭 누르기",
          "caption": "「이슈 정보」가 열립니다. 「측정」 탭을 누릅니다."
        },
        {
          "title": "날짜 칸 열기",
          "caption": "면 이슈는 평면·입체 면적과 표면적이 나옵니다. 위쪽 날짜 칸을 누릅니다."
        },
        {
          "title": "비교할 날짜 고르기",
          "caption": "이 이슈가 있는 촬영일이 나옵니다. 비교할 날짜를 고릅니다."
        },
        {
          "title": "패널 내리기",
          "caption": "고른 날짜마다 측정 카드가 붙고, 아래 「비교」에 차이가 나옵니다. 패널을 내립니다."
        },
        {
          "title": "바닥면 높이 넣기",
          "caption": "체적은 바닥면 높이를 넣고 구합니다."
        },
        {
          "title": "「체적 계산」 누르기",
          "caption": "「체적 계산」을 누릅니다."
        },
        {
          "title": "날짜별 체적 보기",
          "caption": "날짜마다 바닥면보다 위는 CUT(절토량), 아래는 FILL(성토량)으로 나옵니다."
        },
        {
          "title": "선 이슈 누르기",
          "caption": "이번엔 지도에서 선 이슈를 누릅니다."
        },
        {
          "title": "「측정」 탭 누르기",
          "caption": "「측정」 탭을 누릅니다."
        },
        {
          "title": "패널 내리기",
          "caption": "선 이슈는 평면·입체·표면 거리가 나옵니다. 패널을 내립니다."
        },
        {
          "title": "「선분」 펼치기",
          "caption": "맨 아래 「선분」을 펼칩니다."
        },
        {
          "title": "선분별 값 보기",
          "caption": "선분마다 거리·고도 차·경사가 나옵니다."
        }
      ]
    },
    "t-issueexport": {
      "title": "이슈 내보내기",
      "note": "오른쪽 <ui>선택 시계열</ui>에서 날짜를 빼고 <ui>확인</ui>을 누르면 그 촬영일의 이슈가 지워집니다.",
      "steps": [
        {
          "title": "이슈 누르기",
          "caption": "다른 촬영일로 이어 볼 이슈를 누릅니다."
        },
        {
          "title": "패널 내리기",
          "caption": "「이슈 정보」가 열립니다. 강도 추이에 촬영일이 하나뿐입니다. 패널을 내립니다."
        },
        {
          "title": "「이슈 내보내기」 누르기",
          "caption": "아래쪽 「이슈 내보내기」를 누릅니다."
        },
        {
          "title": "촬영일 고르기",
          "caption": "「분석 시계열 선택」 창입니다. 왼쪽 「시계열 리스트」에서 내보낼 촬영일을 고릅니다."
        },
        {
          "title": "「>」로 옮기기",
          "caption": "가운데 「>」로 오른쪽 「선택 시계열」에 옮깁니다. 「»」는 기준일 이전·이후 날짜를 한꺼번에 옮깁니다."
        },
        {
          "title": "「확인」 누르기",
          "caption": "「확인」을 누릅니다."
        },
        {
          "title": "완료 알림 확인",
          "caption": "「이슈 연계 성공」 알림이 뜹니다."
        },
        {
          "title": "늘어난 강도 추이 보기",
          "caption": "「이슈 강도 추이」에 고른 촬영일이 더해져, 같은 이슈를 날짜별로 이어 봅니다."
        }
      ]
    },
    "t-droneimg": {
      "title": "드론 원본 사진 보기",
      "steps": [
        {
          "title": "「드론 이미지」 도구 고르기",
          "caption": "그리기 도구 「기타」의 「드론 이미지」(카메라 아이콘)를 누릅니다."
        },
        {
          "title": "지도 클릭하기",
          "caption": "사진을 볼 자리를 지도에서 클릭합니다."
        },
        {
          "title": "다른 썸네일 고르기",
          "caption": "아래 「이미지 리스트」에 그 자리에서 100m 안에서 찍은 원본 사진이 나옵니다. 다른 썸네일을 누릅니다."
        },
        {
          "title": "전체화면 누르기",
          "caption": "카드가 그 사진으로 바뀌고 지도에 촬영 위치가 표시됩니다. 카드의 전체화면 버튼을 누릅니다."
        },
        {
          "title": "옆 사진으로 넘기기",
          "caption": "사진이 화면 가득 열립니다. 아래 화살표로 옆 사진으로 넘깁니다."
        },
        {
          "title": "옆 사진 보기",
          "caption": "옆 사진으로 넘어갑니다."
        }
      ]
    },
    "t-geolog": {
      "title": "사진·영상(지오로그)",
      "steps": [
        {
          "title": "「GEOLOG」 열기",
          "caption": "왼쪽 레일의 「GEOLOG」를 누릅니다."
        },
        {
          "title": "「+」 누르기",
          "caption": "현장 사진·영상 목록입니다. 위쪽 「+」를 누릅니다."
        },
        {
          "title": "「파일 업로드」 고르기",
          "caption": "「파일 업로드」·「폴더 업로드」·「지도 위로 업로드」 중 「파일 업로드」를 고릅니다."
        },
        {
          "title": "「위치 설정」 누르기",
          "caption": "고른 사진이 바로 올라갑니다. 위치가 없는 사진은 「위치 없음」으로 표시되고 지도에 핀이 없습니다. 「위치 설정」을 누릅니다."
        },
        {
          "title": "「위치 지정」 고르기",
          "caption": "「위치 지정」을 고릅니다."
        },
        {
          "title": "사진 고르기",
          "caption": "위치를 정할 사진을 고릅니다."
        },
        {
          "title": "「지도에 지정」 누르기",
          "caption": "「지도에 지정」을 누릅니다."
        },
        {
          "title": "찍은 자리 클릭하기",
          "caption": "지도에서 사진을 찍은 자리를 클릭합니다."
        },
        {
          "title": "「상세 보기」 누르기",
          "caption": "그 자리에 사진 핀과 미리보기 카드가 생깁니다. 카드의 「상세 보기」를 누릅니다."
        },
        {
          "title": "큰 창에서 보기",
          "caption": "큰 창에서 사진을 크게 보고 등록자·촬영일·주제를 확인합니다."
        }
      ]
    },
    "t-report": {
      "title": "리포트",
      "note": "리포트에는 <ui>ISSUE</ui> 필터와 상관없이 지금 촬영일의 이슈가 모두 들어갑니다.",
      "steps": [
        {
          "title": "「REPORT」 열기",
          "caption": "왼쪽 레일의 「REPORT」를 누릅니다."
        },
        {
          "title": "제목 넣기",
          "caption": "작성자 정보는 내 정보로 채워져 있습니다. 리포트 제목을 넣습니다."
        },
        {
          "title": "「리포트 내보내기」 누르기",
          "caption": "「리포트 내보내기」를 누릅니다."
        },
        {
          "title": "「PDF 다운로드」 누르기",
          "caption": "A4 미리보기가 열립니다. 위쪽 「PDF 다운로드」를 누르면 PDF 파일로 받습니다."
        }
      ]
    },
    "t-capture": {
      "title": "좌표 확인과 영역 캡쳐",
      "steps": [
        {
          "title": "지도 클릭하기",
          "caption": "좌표를 볼 자리를 지도에서 클릭합니다."
        },
        {
          "title": "좌표계 메뉴 열기",
          "caption": "오른쪽 아래 좌표 바에 그 자리의 x·y·z가 나옵니다. 왼쪽 좌표계 칸을 누릅니다."
        },
        {
          "title": "「Google Mercator」 고르기",
          "caption": "보고 싶은 좌표계를 고릅니다. 「Google Mercator」를 누릅니다."
        },
        {
          "title": "바뀐 좌표 확인",
          "caption": "좌표가 고른 좌표계로 바뀝니다."
        },
        {
          "title": "「영역 캡쳐」 고르기",
          "caption": "이번엔 그리기 도구 「기타」의 「영역 캡쳐」를 누릅니다."
        },
        {
          "title": "영역 지정 안내 보기",
          "caption": "지도에서 캡쳐할 영역을 끌어 지정하라는 안내가 뜹니다."
        },
        {
          "title": "영역 끌어 지정하기",
          "caption": "지도에서 캡쳐할 영역을 끕니다."
        },
        {
          "title": "출력 배율 고르기",
          "caption": "지상 크기·출력 크기·유효 GSD가 나옵니다. 출력 배율을 고릅니다."
        },
        {
          "title": "「PNG 로 내려받기」 누르기",
          "caption": "출력 크기가 네 배가 됩니다. 「PNG 로 내려받기」를 누르면 PNG 파일로 받습니다."
        }
      ]
    },
    "t-pf-dxf": {
      "title": "DXF 단면 확인 (2D)",
      "note": "선형 레이어(DXF)는 <a href=\"#t-layerdata\">레이어 데이터</a>에서 「선형 Layer」 상자에 올립니다.",
      "steps": [
        {
          "title": "「LAYER」 누르기",
          "caption": "2D 점검 화면 왼쪽 레일의 「LAYER」를 누릅니다."
        },
        {
          "title": "「선형 레이어」 펼치기",
          "caption": "레이어 패널입니다. 「선형 레이어」를 펼칩니다."
        },
        {
          "title": "「단면 그래프 열기」 누르기",
          "caption": "올려 둔 선형 레이어(DXF)가 보입니다. 행 오른쪽 그래프 아이콘(「단면 그래프 열기」)을 누릅니다."
        },
        {
          "title": "「종단면」 「확인」 누르기",
          "caption": "단면 설정 패널이 열리고, 지도에 노선과 측점(0+000, 0+020 …)이 그려집니다. 「종단면」의 「확인」을 누릅니다."
        },
        {
          "title": "그래프 선 위 누르기",
          "caption": "아래에 종단면 그래프가 열립니다. 가로는 시점에서 잰 거리, 세로는 높이입니다. 그래프 선 위를 누릅니다."
        },
        {
          "title": "지도에서 위치 보기",
          "caption": "누른 지점이 지도의 노선 위에 점으로 표시되고, 그래프 아래 줄에 그 지점의 좌표와 높이가 나옵니다."
        },
        {
          "title": "「종점」에 80 넣기",
          "caption": "이어서 횡단면을 봅니다. 설정 패널 「횡단면」의 「종점」에 80 을 넣습니다."
        },
        {
          "title": "「확인」 누르기",
          "caption": "폭(좌·우 10 m)과 횡단 간격(20 m)은 그대로 두고 「확인」을 누릅니다."
        },
        {
          "title": "「다음 단면」 누르기",
          "caption": "첫 측점의 횡단면 그래프가 열리고, 지도에 측점마다 횡단면 선이 그려집니다(지금 측점은 빨강). 그래프 머리줄의 「다음 단면」(›)을 누릅니다."
        },
        {
          "title": "지도에서 횡단면 선 누르기",
          "caption": "다음 측점(020)으로 넘어갑니다. 지도에서 0+060 횡단면 선을 눌러도 그 측점으로 바뀝니다."
        },
        {
          "title": "「저장」 누르기",
          "caption": "그래프가 그 측점(060)으로 바뀝니다. 이 구간을 저장해 두려면 「저장」을 누릅니다."
        },
        {
          "title": "저장 알림 보기",
          "caption": "「횡단면이 저장되었습니다.」 알림이 뜹니다."
        },
        {
          "title": "저장한 구간 카드 누르기",
          "caption": "「저장된 횡단면」 목록이 펼쳐집니다. 저장한 구간 카드(0 ~ 080)를 누릅니다."
        },
        {
          "title": "측점 50 넣기",
          "caption": "구간 정보와 측점 목록이 나옵니다. 아래 칸에 50 을 넣습니다."
        },
        {
          "title": "「특별 횡단면 추가」 누르기",
          "caption": "오른쪽 「특별 횡단면 추가」(+)를 누릅니다."
        },
        {
          "title": "추가 알림 보기",
          "caption": "「특별 횡단면이 추가되었습니다.」 알림이 뜹니다."
        },
        {
          "title": "050 측점 누르기",
          "caption": "목록에 050 측점이 더해집니다. 050 을 누릅니다."
        },
        {
          "title": "050 측점부터 보기",
          "caption": "저장한 구간의 그래프가 050 측점부터 열립니다."
        }
      ]
    },
    "t-pf-dxf3d": {
      "title": "DXF 단면 확인 (3D)",
      "steps": [
        {
          "title": "「LAYER」 누르기",
          "caption": "3D 화면 왼쪽 레일의 「LAYER」를 누릅니다."
        },
        {
          "title": "「선형 레이어」 펼치기",
          "caption": "3D 레이어 패널입니다. 「선형 레이어」를 펼칩니다."
        },
        {
          "title": "「단면 그래프 열기」 누르기",
          "caption": "행 오른쪽 그래프 아이콘(「단면 그래프 열기」)을 누릅니다."
        },
        {
          "title": "「종단면」 「확인」 누르기",
          "caption": "2D 화면과 같은 단면 설정 패널이 열립니다. 「종단면」의 「확인」을 누릅니다."
        },
        {
          "title": "「횡단면」 「확인」 누르기",
          "caption": "모델 위에 측점이 표시되고, 아래에 종단면 그래프가 열립니다. 「횡단면」의 「확인」을 누릅니다."
        },
        {
          "title": "모델 위 횡단면 선 누르기",
          "caption": "모델 위에 측점마다 횡단면 선이 그려지고, 첫 측점의 횡단면 그래프가 열립니다. 모델 위 0+040 횡단면 선을 누릅니다."
        },
        {
          "title": "그 측점 횡단면 보기",
          "caption": "아래 그래프가 그 측점(040)의 횡단면으로 바뀝니다."
        }
      ]
    },
    "t-pf-export": {
      "title": "DXF 단면 내보내기",
      "note": "내보내기는 저장한 구간에서만 할 수 있습니다. 먼저 <a href=\"#t-pf-dxf\">DXF 단면 확인 (2D)</a>에서 구간을 저장합니다.",
      "steps": [
        {
          "title": "「저장된 횡단면」 누르기",
          "caption": "저장해 둔 구간의 횡단면을 파일로 내보냅니다. 「횡단면」의 「저장된 횡단면」을 누릅니다."
        },
        {
          "title": "「반출」 누르기",
          "caption": "저장한 구간 카드 오른쪽 내보내기 아이콘(「반출」)을 누릅니다."
        },
        {
          "title": "「촬영일」 누르기",
          "caption": "「횡단면 데이터 내보내기」 창입니다. 위에 구간·폭·간격이 나옵니다. 「촬영일」을 눌러 담을 날짜를 고릅니다."
        },
        {
          "title": "촬영일 고르기",
          "caption": "촬영일 목록입니다. 여러 날을 함께 고를 수 있습니다. 2024/01/19 를 고릅니다."
        },
        {
          "title": "「생성」 누르기",
          "caption": "고른 촬영일이 들어갔습니다. 지반고·계획고는 설계도가 하나라 처음부터 골라져 있습니다. 「생성」을 누릅니다."
        },
        {
          "title": "생성 알림 보기",
          "caption": "오른쪽 위에 「파일 생성이 시작되었습니다.」 알림이 뜹니다."
        },
        {
          "title": "창 닫기",
          "caption": "아래 목록에 「생성중」 파일이 생깁니다. 목록은 창을 다시 열 때 새로 고쳐집니다. 창을 닫습니다."
        },
        {
          "title": "「반출」 다시 누르기",
          "caption": "생성이 끝날 즈음 「반출」을 다시 누릅니다."
        },
        {
          "title": "완료된 파일 고르기",
          "caption": "목록이 새로 고쳐져 상태가 「완료」로 바뀌었습니다. 파일 앞 체크 상자를 눌러 고릅니다."
        },
        {
          "title": "「다운로드」 누르기",
          "caption": "파일이 골라졌습니다. 「다운로드」를 누릅니다."
        },
        {
          "title": "CSV 형식 고르기",
          "caption": "받을 형식(CSV·DXF·토공 집계표·토공 횡단수량)을 고릅니다. CSV 를 누릅니다."
        },
        {
          "title": "다운로드 알림 보기",
          "caption": "오른쪽 위에 「CSV 파일이 다운로드되었습니다.」 알림이 뜹니다."
        }
      ]
    },
    "t-pf-issue": {
      "title": "선 이슈 단면 확인 (2D)",
      "steps": [
        {
          "title": "선 이슈 누르기",
          "caption": "2D 지도에서 선 이슈를 누릅니다."
        },
        {
          "title": "「측정」 탭 누르기",
          "caption": "「이슈 정보」가 열립니다. 「측정」 탭을 누릅니다."
        },
        {
          "title": "「단면 확인」 누르기",
          "caption": "선 길이 아래에 「단면」과 「횡단면」 설정이 있습니다. 「단면」의 선분 구간(P1~P3)은 그대로 두고 「단면 확인」을 누릅니다."
        },
        {
          "title": "패널 내리기",
          "caption": "이슈 선을 따라 자른 종단면 그래프가 아래에 열립니다. 이번에는 횡단면을 봅니다. 「이슈 정보」 패널을 아래로 내립니다."
        },
        {
          "title": "「횡단면 확인」 누르기",
          "caption": "「횡단면」에서 선분 구간·시작 측점·횡단 간격·폭을 정하고 「횡단면 확인」을 누릅니다."
        },
        {
          "title": "이슈 선 횡단면 보기",
          "caption": "이슈 선을 따라 횡단 간격마다 횡단면이 열리고, 지도에 측점마다 횡단면 선이 그려집니다."
        }
      ]
    },
    "t-pf-issue3d": {
      "title": "선 이슈 단면 확인 (3D)",
      "steps": [
        {
          "title": "「ISSUE」 누르기",
          "caption": "3D 화면에서도 선 이슈로 단면을 볼 수 있습니다. 왼쪽 레일의 「ISSUE」를 누릅니다."
        },
        {
          "title": "유형 머리 펼치기",
          "caption": "이슈가 유형별로 묶여 있습니다. 선 이슈가 있는 유형(「변형」)을 펼칩니다."
        },
        {
          "title": "「이슈로 이동」 누르기",
          "caption": "선 이슈 행의 「이슈로 이동」을 누릅니다."
        },
        {
          "title": "오른쪽 버튼으로 기울이기",
          "caption": "카메라가 이슈 위로 옮겨 가 바로 내려다보고, 「이슈 정보」가 열립니다. 오른쪽 버튼을 누른 채 위로 끌어 모델을 기울입니다."
        },
        {
          "title": "「측정」 탭 누르기",
          "caption": "모델을 비스듬히 봅니다. 「측정」 탭을 누릅니다."
        },
        {
          "title": "「단면 확인」 누르기",
          "caption": "2D 화면과 같은 「단면 · 횡단면」 설정이 있습니다. 「단면 확인」을 누릅니다."
        },
        {
          "title": "3D 화면에서 그래프 보기",
          "caption": "이슈 선을 따라 자른 종단면 그래프가 아래에 열리고, 모델 위에 꼭짓점 번호(1·2·3)가 표시됩니다."
        }
      ]
    },
    "t-pf-3d": {
      "title": "3D 단면 측정 도구",
      "steps": [
        {
          "title": "「종단 측정」 누르기",
          "caption": "3D 점검 화면에서는 모델 위에 직접 선을 그려 단면을 볼 수 있습니다. 왼쪽 도구 막대 「측정」 묶음의 「종단 측정」을 누릅니다."
        },
        {
          "title": "첫 점 찍기",
          "caption": "모델 위를 눌러 선의 첫 점을 찍습니다. 굴착부를 따라 찍습니다."
        },
        {
          "title": "다음 점 찍기",
          "caption": "다음 점을 찍습니다."
        },
        {
          "title": "더블클릭으로 끝내기",
          "caption": "마지막 점은 더블클릭으로 찍어 끝냅니다."
        },
        {
          "title": "그래프 보기",
          "caption": "그린 선을 따라 자른 종단면 그래프가 아래에 열립니다."
        }
      ]
    },
    "t-pf-view": {
      "title": "그래프 활용(1) 조작",
      "steps": [
        {
          "title": "「부분 모드」 켜기",
          "caption": "「선 이슈 단면 확인 (3D)」에서 연 그래프입니다. 꼭짓점이 셋 이상인 선은 「부분 모드」로 선분 하나씩 볼 수 있습니다. 「부분 모드」를 켭니다."
        },
        {
          "title": "「다음 구간」 누르기",
          "caption": "첫 선분(P1–P2)만 그래프에 나옵니다. 「다음 구간」을 누릅니다."
        },
        {
          "title": "휠로 확대하기",
          "caption": "다음 선분(P2–P3)으로 넘어갑니다. 그래프 위에서 휠을 굴리면 커서 자리를 기준으로 확대됩니다."
        },
        {
          "title": "끌어서 옮기기",
          "caption": "확대됐습니다. 그래프를 끌어 옆으로 옮깁니다."
        },
        {
          "title": "「더보기」 누르기",
          "caption": "옮겨졌습니다. 머리줄에 다 들어가지 않는 도구는 「더보기」에 모여 있습니다. 「더보기」를 누릅니다."
        },
        {
          "title": "「화면 초기화」 누르기",
          "caption": "「화면 초기화」를 누르면 처음 범위로 돌아갑니다."
        },
        {
          "title": "손잡이로 그래프 칸 키우기",
          "caption": "처음 범위로 돌아왔습니다. 패널 위 손잡이를 위로 끌면 그래프 칸이 커집니다."
        },
        {
          "title": "「더보기」 누르기",
          "caption": "그래프 칸이 커졌습니다. 다시 「더보기」를 누릅니다."
        },
        {
          "title": "「투명도」 막대 끌기",
          "caption": "「투명도」 막대를 오른쪽으로 끕니다."
        },
        {
          "title": "「투명도」 되돌리기",
          "caption": "그래프 패널이 비쳐 뒤의 3D 모델이 보입니다. 막대를 왼쪽 끝으로 끌어 되돌립니다."
        },
        {
          "title": "「다크 테마」 누르기",
          "caption": "패널이 다시 불투명해집니다. 같은 메뉴의 「다크 테마」를 누릅니다."
        },
        {
          "title": "「전체 화면」 누르기",
          "caption": "배경이 어두워집니다. 그래프 오른쪽 위 「전체 화면」을 누르면 그래프만 화면 가득 봅니다."
        },
        {
          "title": "그래프 선 위 누르기",
          "caption": "그래프 선 위를 누르면 그 지점이 고정되고, 아래 줄에 X·Y·Z 좌표가 나옵니다."
        },
        {
          "title": "좌표계 칸 누르기",
          "caption": "좌표계 칸(Korea2000)을 누릅니다."
        },
        {
          "title": "「WGS84」 고르기",
          "caption": "Google Mercator·WGS84·UTM 중에서 「WGS84」를 고릅니다."
        },
        {
          "title": "「좌표 복사」 누르기",
          "caption": "경도·위도·높이로 바뀝니다. 오른쪽 「좌표 복사」를 누릅니다."
        },
        {
          "title": "「복사됨」 보기",
          "caption": "「복사됨」이 뜨고 좌표가 복사됩니다."
        }
      ]
    },
    "t-pf-layers": {
      "title": "그래프 활용(2) 레이어 비교",
      "note": "「계획」 묶음의 설계도 표면은 <a href=\"#t-terrain\">지형 고도 데이터</a>에서 설계도를 올리면 생깁니다.",
      "steps": [
        {
          "title": "「레이어 4」 누르기",
          "caption": "횡단면 그래프입니다. 왼쪽 위 「레이어 4」를 누릅니다."
        },
        {
          "title": "「현황 Mesh」 펼치기",
          "caption": "현황 Mesh·BIM·Point Cloud·계획·지층·벡터 묶음이 있습니다. 「현황 Mesh」를 펼칩니다."
        },
        {
          "title": "다른 촬영일 켜기",
          "caption": "촬영일마다 Mesh 가 있습니다. 2024-01-25 를 켭니다."
        },
        {
          "title": "목록 내리기",
          "caption": "두 촬영일 단면이 색을 달리해 겹쳐 그려집니다(01-25 에는 굴착부가 덮여 있습니다). 목록을 아래로 내립니다."
        },
        {
          "title": "「계획」 펼치기",
          "caption": "아래쪽에 「계획」 묶음이 있습니다. 「계획」을 펼칩니다."
        },
        {
          "title": "「계획고」 켜기",
          "caption": "설계도 표면(원지반고·계획고)이 있습니다. 「계획고」를 켭니다."
        },
        {
          "title": "「원지반고」 켜기",
          "caption": "설계 굴착 바닥(계획고)이 그려집니다. 「원지반고」도 켭니다."
        },
        {
          "title": "「원본」 누르기",
          "caption": "굴착 전 지면(원지반고)까지 현황과 함께 보입니다. 「색상 모드」의 「원본」을 누릅니다."
        },
        {
          "title": "실제 색으로 보기",
          "caption": "현황 선이 모델의 실제 색으로 칠해집니다."
        }
      ]
    },
    "t-pf-measure": {
      "title": "그래프 활용(3) 측정",
      "steps": [
        {
          "title": "「직선 측정」 누르기",
          "caption": "040 측점 횡단면의 굴착부를 잽니다. 「그리기」의 「직선 측정」을 누릅니다."
        },
        {
          "title": "왼쪽 위 모서리 누르기",
          "caption": "단면 선 위를 눌러 점을 찍습니다. 굴착부 왼쪽 위 모서리를 누릅니다."
        },
        {
          "title": "바닥 점 찍기",
          "caption": "굴착 바닥(벽 바로 아래)을 누릅니다. 마지막 점에서 커서까지 점선과 길이가 따라옵니다."
        },
        {
          "title": "우클릭으로 끝내기",
          "caption": "그래프를 오른쪽 버튼으로 누르면 측정이 끝납니다."
        },
        {
          "title": "「점 측정」 누르기",
          "caption": "구간 길이(굴착 깊이)가 붙고, 점마다 좌표 상자가 뜹니다. 「점 측정」을 누릅니다."
        },
        {
          "title": "바닥 오른쪽 끝 누르기",
          "caption": "단면 선 위 한 점을 누르면 그 점의 좌표가 나옵니다. 굴착 바닥 오른쪽 끝을 누릅니다."
        },
        {
          "title": "「라벨: 고정」 누르기",
          "caption": "점의 좌표 상자가 뜹니다. 상자가 길이를 가리면 「라벨: 고정」을 눌러 「호버」로 바꿉니다."
        },
        {
          "title": "「그리드 측정」 누르기",
          "caption": "좌표 상자는 점에 마우스를 올릴 때만 보이고 길이만 남습니다. 「그리드 측정」을 누릅니다."
        },
        {
          "title": "첫 모서리 누르기",
          "caption": "사각형의 대각선 양 끝을 차례로 누릅니다. 오른쪽 관의 왼쪽 위를 누릅니다."
        },
        {
          "title": "맞은편 모서리 누르기",
          "caption": "관 오른쪽 아래(굴착 바닥)를 누릅니다."
        },
        {
          "title": "「원 측정」 누르기",
          "caption": "관의 폭(가로)·높이(세로)·대각선 길이가 나옵니다. 「원 측정」을 누릅니다."
        },
        {
          "title": "원 중심 누르기",
          "caption": "원의 중심을 먼저 누릅니다. 왼쪽 관 가운데를 누릅니다."
        },
        {
          "title": "원 가장자리 누르기",
          "caption": "관 윗면을 누릅니다."
        },
        {
          "title": "「축 측정」 누르기",
          "caption": "반지름(R)이 나옵니다. 「축 측정」을 누릅니다."
        },
        {
          "title": "도로 아래 한 점 누르기",
          "caption": "커서를 지나는 가로·세로 선이 단면 선과 만나는 점을 미리 보여 줍니다. 굴착부 오른쪽 도로 아래를 누릅니다."
        },
        {
          "title": "「측정 삭제」 누르기",
          "caption": "만나는 점 사이 거리가 붙습니다. 「측정 삭제」를 누릅니다."
        },
        {
          "title": "「전체 삭제」 누르기",
          "caption": "「선택 삭제」는 누른 측정 하나만, 「전체 삭제」는 모두 지웁니다. 「전체 삭제」를 누릅니다."
        },
        {
          "title": "측정이 지워진 그래프 보기",
          "caption": "그래프 위 측정이 모두 지워집니다."
        }
      ]
    },
    "t-pf-image": {
      "title": "그래프 활용(4) 캡처·추출",
      "steps": [
        {
          "title": "「이미지 캡처」 누르기",
          "caption": "그래프를 그림 파일로 받으려면 「이미지 캡처」를 누릅니다."
        },
        {
          "title": "「PNG」 고르기",
          "caption": "PNG·JPG·JPEG·WEBP 중 형식을 고릅니다. 「PNG」를 누릅니다."
        },
        {
          "title": "「점 간격 추출」 누르기",
          "caption": "그래프 그림이 PNG 파일로 내려받아집니다. 높이 값을 파일로 받으려면 「점 간격 추출」을 누릅니다."
        },
        {
          "title": "점 간격 2 넣기",
          "caption": "「데이터 추출」 창이 열리고, 그래프 선이 「점 간격」마다 찍은 점을 이은 선으로 바뀝니다. 점 간격에 2 를 넣습니다."
        },
        {
          "title": "CSV 형식 고르기",
          "caption": "선이 2 m 간격의 점을 이은 선으로 다시 그려집니다. 형식(TXT·CSV·DXF) 중 CSV 를 누릅니다."
        },
        {
          "title": "「확인」 누르기",
          "caption": "확인창에 파일에 담길 레이어와 점 간격이 나옵니다. 「확인」을 누르면 파일이 내려받아집니다."
        }
      ]
    },
    "t-pf-qty": {
      "title": "그래프 활용(5) 수량표",
      "steps": [
        {
          "title": "「수량표」 누르기",
          "caption": "설계도의 계획고·원지반고를 켠 횡단면입니다. 「수량표」를 누릅니다."
        },
        {
          "title": "「엑셀 다운로드」 누르기",
          "caption": "「횡단 수량표」 창입니다. 이 측점의 원지반고·계획고·현황고와 쌓기·깎기 면적을 계획(파랑)·진행(초록)으로 보여 줍니다. 「엑셀 다운로드」를 누르면 표가 파일로 내려받아집니다."
        }
      ]
    },
    "t-camera": {
      "title": "카메라 조작",
      "note": "도구를 고르지 않았을 때만 더블클릭으로 그 지점에 다가갑니다. 오른쪽 아래 안내처럼 왼쪽 버튼 끌기는 평행이동, 오른쪽 버튼 끌기는 회전·틸팅, 휠은 줌인·줌아웃입니다.",
      "steps": [
        {
          "title": "「3D」 누르기",
          "caption": "2D 점검 화면 왼쪽 레일의 「3D」를 누릅니다."
        },
        {
          "title": "휠로 다가가기",
          "caption": "같은 촬영일의 3D 모델이 위에서 내려다본 시점으로 열립니다. 휠을 위로 굴려 다가갑니다."
        },
        {
          "title": "오른쪽 버튼으로 기울이기",
          "caption": "모델에 다가갔습니다. 오른쪽 버튼을 누른 채 위로 끌어 기울입니다."
        },
        {
          "title": "오른쪽 버튼으로 돌리기",
          "caption": "비스듬히 내려다보는 시점이 됐습니다. 오른쪽 버튼을 누른 채 옆으로 끌면 돌아갑니다."
        },
        {
          "title": "왼쪽 버튼으로 옮기기",
          "caption": "방향이 돌아갔습니다. 왼쪽 버튼을 누른 채 끌어 모델을 옮깁니다."
        },
        {
          "title": "「배경색 변경」 누르기",
          "caption": "「기타」의 「배경색 변경」을 누릅니다."
        },
        {
          "title": "바탕색 고르기",
          "caption": "색 목록이 열립니다. 바탕색을 고릅니다."
        },
        {
          "title": "더블클릭으로 다가가기",
          "caption": "모델 바깥 바탕이 고른 색으로 바뀝니다. 보고 싶은 곳을 더블클릭하면 그 지점으로 다가갑니다."
        },
        {
          "title": "「TOP」 누르기",
          "caption": "그 지점으로 다가갔습니다. 오른쪽 위 방향 큐브의 「TOP」을 누릅니다."
        },
        {
          "title": "위에서 본 시점 보기",
          "caption": "위에서 내려다본 시점으로 바뀝니다."
        }
      ]
    },
    "t-fly": {
      "title": "1인칭 비행",
      "steps": [
        {
          "title": "「1인칭 시점 전환」 누르기",
          "caption": "오른쪽 아래 「1인칭 시점 전환」을 누릅니다."
        },
        {
          "title": "조작 방법 1장 넘기기",
          "caption": "「1인칭 시점 조작 방법」 창이 열립니다. W·A·S·D 로 움직이고, 연타하면 빨리 갑니다. 「다음」을 누릅니다."
        },
        {
          "title": "조작 방법 2장 넘기기",
          "caption": "두 번째 장 — Space 로 올라가고 Shift 로 내려갑니다. 「다음」을 누릅니다."
        },
        {
          "title": "「시작」 누르기",
          "caption": "세 번째 장 — 휠로 줌인·줌아웃하고, 우클릭으로 끝냅니다. 「시작」을 누릅니다."
        },
        {
          "title": "W 로 앞으로 가기",
          "caption": "1인칭 시점입니다. 가운데 십자선과 오른쪽 아래 키 안내가 뜹니다. 마우스를 움직이면 시점이 돌아가고, W 를 누르고 있으면 앞으로 갑니다."
        },
        {
          "title": "우클릭으로 끝내기",
          "caption": "앞으로 왔습니다. 우클릭(또는 Esc)하면 1인칭 시점이 끝납니다."
        },
        {
          "title": "원래 조작 보기",
          "caption": "끌기·휠로 움직이는 원래 조작으로 돌아왔습니다."
        }
      ]
    },
    "t-3dlayer": {
      "title": "3D 레이어",
      "note": "GIS·선형·BIM·Point Cloud 레이어는 <a href=\"#t-layerdata\">레이어 데이터</a>에서 올립니다.",
      "steps": [
        {
          "title": "「LAYER」 열기",
          "caption": "왼쪽 레일의 「LAYER」를 누릅니다."
        },
        {
          "title": "「DSM」 켜기",
          "caption": "3D 레이어 패널입니다. 「DSM」을 켭니다."
        },
        {
          "title": "높이 색 보기",
          "caption": "모델이 높이에 따라 색칠되고, DSM 아래에 낮음(Lowest)–높음(Highest) 범례가 붙습니다."
        },
        {
          "title": "「DSM」 끄기",
          "caption": "「DSM」을 끕니다."
        },
        {
          "title": "투명도 막대 끌기",
          "caption": "「Mesh」의 「투명도」 막대를 끌어 모델을 반투명하게 합니다."
        },
        {
          "title": "투명도 되돌리기",
          "caption": "모델이 반투명해져 뒤쪽이 비쳐 보입니다. 막대를 왼쪽 끝으로 끌어 되돌립니다."
        },
        {
          "title": "「어노테이션」 켜기",
          "caption": "모델이 다시 불투명해졌습니다. 「어노테이션」을 켭니다."
        },
        {
          "title": "이슈 보기",
          "caption": "이슈가 모델 위에 그려집니다."
        },
        {
          "title": "「선형 레이어」 펼치기",
          "caption": "「선형 레이어」를 펼칩니다."
        },
        {
          "title": "계획 노선 켜기",
          "caption": "선형 레이어 목록입니다. 「열배관_계획노선」을 켭니다."
        },
        {
          "title": "그려진 노선 보기",
          "caption": "계획 노선이 모델 위에 그려집니다."
        },
        {
          "title": "「모델로 이동」 누르기",
          "caption": "「Mesh」 오른쪽 과녁 단추(「모델로 이동」)를 누릅니다."
        },
        {
          "title": "모델 전체 보기",
          "caption": "모델 전체가 보이도록 위에서 본 시점으로 옮겨 갑니다."
        }
      ]
    },
    "t-measure3d": {
      "title": "거리·수직 측정",
      "note": "측정은 저장되지 않고, 기준 시계열을 바꾸면 지워집니다.",
      "steps": [
        {
          "title": "「거리 측정」 고르기",
          "caption": "「측정」의 「거리 측정」을 고릅니다."
        },
        {
          "title": "첫 점 찍기",
          "caption": "모델 위를 클릭해 첫 점을 찍습니다. 클릭마다 점이 늘고, 더블클릭으로 끝냅니다."
        },
        {
          "title": "다음 점 찍기",
          "caption": "다음 점을 찍습니다. 구간마다 입체 거리가 붙습니다."
        },
        {
          "title": "더블클릭으로 끝내기",
          "caption": "마지막 점은 더블클릭으로 찍어 끝냅니다."
        },
        {
          "title": "구간 거리 보기",
          "caption": "거리 측정이 끝났습니다. 구간마다 입체 거리가 붙어 있습니다."
        },
        {
          "title": "「수직 측정」 고르기",
          "caption": "이번에는 굴착 깊이를 잽니다. 「측정」의 「수직 측정」을 고릅니다."
        },
        {
          "title": "위 점 찍기",
          "caption": "굴착부 옆 도로 면을 클릭합니다."
        },
        {
          "title": "아래 점 찍기",
          "caption": "굴착 바닥을 클릭하면 측정이 끝납니다."
        },
        {
          "title": "높이·수평·입체 거리 보기",
          "caption": "높이(수직)·수평 거리와 두 점 사이 입체 거리가 함께 붙습니다."
        }
      ]
    },
    "t-area3d": {
      "title": "면적·종단 측정",
      "note": "종단 측정 그래프는 <a href=\"#c6\">단면 그래프</a> 장의 그래프와 같은 화면입니다.",
      "steps": [
        {
          "title": "「면적 측정」 고르기",
          "caption": "「측정」의 「면적 측정」을 고릅니다."
        },
        {
          "title": "첫 꼭짓점 찍기",
          "caption": "모델 위를 클릭해 첫 꼭짓점을 찍습니다."
        },
        {
          "title": "둘째 꼭짓점 찍기",
          "caption": "다음 꼭짓점을 찍습니다."
        },
        {
          "title": "셋째 꼭짓점 찍기",
          "caption": "변이 생기고 거리가 붙습니다. 다음 꼭짓점을 찍습니다."
        },
        {
          "title": "넷째 꼭짓점 찍기",
          "caption": "꼭짓점이 셋이 되면 면적이 붙습니다. 다음 꼭짓점을 찍습니다."
        },
        {
          "title": "더블클릭으로 끝내기",
          "caption": "마지막 꼭짓점은 더블클릭으로 찍어 끝냅니다."
        },
        {
          "title": "면적 보기",
          "caption": "면적 측정이 끝났습니다. 가운데에 입체·평면 면적, 변마다 거리가 붙습니다."
        },
        {
          "title": "「종단 측정」 고르기",
          "caption": "「종단 측정」을 고릅니다."
        },
        {
          "title": "시작점 찍기",
          "caption": "선의 시작점을 클릭합니다."
        },
        {
          "title": "끝점 더블클릭하기",
          "caption": "끝점을 더블클릭합니다."
        },
        {
          "title": "높이 그래프 보기",
          "caption": "그린 선을 따라 잰 높이 그래프가 아래에 열립니다. 굴착부와 배관이 단면으로 보입니다."
        },
        {
          "title": "「측정 지우개」 고르기",
          "caption": "「측정 지우개」를 고릅니다."
        },
        {
          "title": "지울 측정 누르기",
          "caption": "지울 측정(면적)을 클릭합니다."
        },
        {
          "title": "지워진 자리 보기",
          "caption": "면적 측정이 지워졌습니다. 측정은 저장되지 않아 화면을 새로 열어도 사라집니다."
        }
      ]
    },
    "t-issue3d": {
      "title": "3D 이슈",
      "note": "선·사각형·면·글자도 「생성」에서 만들고, 점·글자는 첫 클릭, 사각형은 두 번째 클릭, 선·면은 더블클릭에서 끝납니다. 지금 촬영일에 없는 이슈의 「이슈로 이동」을 누르면 「현재 시계열에 없는 이슈」 창이 뜹니다.",
      "steps": [
        {
          "title": "「점」 도구 고르기",
          "caption": "「생성」의 「점」을 고릅니다."
        },
        {
          "title": "모델 위 클릭하기",
          "caption": "이슈 레이어가 꺼져 있었다면 자동으로 켜지고 알림이 뜹니다. 이슈를 둘 자리를 모델 위에서 클릭합니다."
        },
        {
          "title": "이슈 정보 보기",
          "caption": "곧바로 「이슈 N」으로 저장되고 왼쪽에 「이슈 정보」가 열립니다. 이름·유형·강도·메모는 「수정」에서 바꿉니다."
        },
        {
          "title": "「ISSUE」 열기",
          "caption": "왼쪽 레일의 「ISSUE」를 누릅니다."
        },
        {
          "title": "유형 머리 펼치기",
          "caption": "이슈가 유형별로 묶여 있습니다. 유형 머리(「변형」)를 펼칩니다."
        },
        {
          "title": "「이슈로 이동」 누르기",
          "caption": "가 볼 이슈 행의 「이슈로 이동」을 누릅니다."
        },
        {
          "title": "「이슈 이름 표시」 누르기",
          "caption": "카메라가 그 이슈로 옮겨 가고 「이슈 정보」가 열립니다. 「기타」의 「이슈 이름 표시」를 누릅니다."
        },
        {
          "title": "숨겨진 이름 보기",
          "caption": "모델 위 이슈 이름이 숨겨집니다. 다시 누르면 다시 보입니다."
        }
      ]
    },
    "t-clip": {
      "title": "절단면 만들기",
      "note": "동시에 켤 수 있는 단면은 8개까지입니다. 목록의 연필 단추로 이름을 바꾸고, 빼기 단추로 지웁니다(지운 단면은 되돌릴 수 없습니다).",
      "steps": [
        {
          "title": "「CLIP」 열기",
          "caption": "왼쪽 레일의 「CLIP」을 누릅니다."
        },
        {
          "title": "「한 변」 넣기",
          "caption": "「절단면 도구」가 열립니다. 「단면 추가」에 「박스」가 골라져 있습니다. 「한 변」에 상자 한 변 길이(m)를 넣습니다."
        },
        {
          "title": "이름 넣기",
          "caption": "이름을 넣습니다. 비워 두면 「박스 1」처럼 순번이 붙습니다."
        },
        {
          "title": "「표면 클릭으로 추가」 누르기",
          "caption": "「표면 클릭으로 추가」를 누릅니다."
        },
        {
          "title": "상자 자리 클릭하기",
          "caption": "「3D 화면에서 모델 표면을 클릭하세요」가 뜹니다. 상자 가운데가 될 자리를 모델 위에서 클릭합니다. 우클릭이나 Esc 는 취소입니다."
        },
        {
          "title": "스위치로 끄기",
          "caption": "상자 안만 남고 나머지는 가려집니다. 「단면 목록」에 상자가 생기고 바로 저장됩니다. 목록 스위치로 단면을 끄고 켭니다."
        },
        {
          "title": "「평면」 고르기",
          "caption": "단면이 꺼져 모델 전체가 보입니다. 다시 켜면 카메라가 그 단면으로 갑니다. 이번에는 「평면」을 고릅니다."
        },
        {
          "title": "「표면 클릭으로 추가」 누르기",
          "caption": "「표면 클릭으로 추가」를 누릅니다."
        },
        {
          "title": "평면 자리 클릭하기",
          "caption": "평면이 지날 자리를 모델 위에서 클릭합니다."
        },
        {
          "title": "수평 평면 보기",
          "caption": "클릭한 높이에 「한 변」 크기의 수평 평면이 생기고, 그 위쪽만 남습니다. 평면을 세워 세로 단면을 보는 법은 「절단면 조절과 저장」에서 봅니다."
        }
      ]
    },
    "t-clipedit": {
      "title": "절단면 조절과 저장",
      "note": "「수직」 조이스틱은 위아래로 옮기고, 세 번째 조이스틱은 박스면 「간격」(높이), 평면이면 「면적」(크기)을 바꿉니다.",
      "steps": [
        {
          "title": "평면 펼치기",
          "caption": "목록에서 평면을 눌러 펼칩니다."
        },
        {
          "title": "「편집」 누르기",
          "caption": "「모서리」는 단면 테두리, 「단면 색칠」은 잘린 면 색칠을 켜고 끕니다. 「반전」은 남기는 쪽을 바꿉니다. 「편집」을 누릅니다."
        },
        {
          "title": "「기울기」 끌기",
          "caption": "편집 중에는 3D 화면의 꼭짓점·면을 직접 끌거나, 아래 조이스틱·막대로 바꿉니다. 「기울기」 막대를 왼쪽 끝까지 끌어 평면을 세웁니다."
        },
        {
          "title": "「수평」 조이스틱 끌기",
          "caption": "평면이 서서 굴착부를 가로지른 단면이 보입니다. 「수평」 조이스틱을 누른 채 끌면 그쪽으로 계속 움직이고, 놓으면 멈춥니다."
        },
        {
          "title": "옮겨진 단면 보기",
          "caption": "단면이 굴착부를 따라 옮겨졌습니다. 「회전」 막대로는 평면 방향을 돌립니다."
        },
        {
          "title": "「저장」 누르기",
          "caption": "바꾼 단면은 이름 옆에 주황 점이 찍히고 「저장」이 켜집니다. 「저장」을 누릅니다."
        },
        {
          "title": "저장 확인",
          "caption": "저장되었습니다. 주황 점이 사라지고 편집이 닫힙니다. 저장하기 전에는 「초기화」로 마지막 저장 모양으로 되돌리고, 편집 중에는 「실행 취소」·「다시 실행」을 씁니다."
        }
      ]
    },
    "t-vector": {
      "title": "벡터",
      "note": "위도/경도 대신 「X/Y 좌표」(프로젝트 좌표계)로도 넣습니다. 패널 위 「지도에 표시」로 벡터를 한꺼번에 숨기고 보입니다.",
      "steps": [
        {
          "title": "「VECTOR」 열기",
          "caption": "왼쪽 레일의 「VECTOR」를 누릅니다."
        },
        {
          "title": "「좌표 입력으로 생성」 누르기",
          "caption": "「벡터」 패널입니다. 「좌표 입력으로 생성」을 누릅니다."
        },
        {
          "title": "이름 넣기",
          "caption": "「벡터 생성」 창입니다. 이름을 넣습니다."
        },
        {
          "title": "「원기둥」 고르기",
          "caption": "형태(선·원기둥·사각기둥)를 고릅니다. 「원기둥」을 누릅니다."
        },
        {
          "title": "반지름 넣기",
          "caption": "「반지름(m)」을 넣습니다. 사각기둥은 「한 변(m)」을 넣습니다."
        },
        {
          "title": "좌표 넣기",
          "caption": "점마다 위도·경도·높이(m)를 넣습니다. 높이는 표고이고, 「점 추가」로 점을 늘립니다(2~100개)."
        },
        {
          "title": "「생성」 누르기",
          "caption": "「생성」을 누릅니다."
        },
        {
          "title": "그려진 원기둥 보기",
          "caption": "목록에 벡터가 생기고 3D 화면 굴착부에 원기둥이 그려집니다."
        },
        {
          "title": "벡터 펼치기",
          "caption": "벡터를 눌러 펼칩니다."
        },
        {
          "title": "「수직 단면」 누르기",
          "caption": "「정보」에서 이름·형태·반지름·색·메모를, 「좌표 목록」에서 좌표를 고치고 「저장」합니다. 「수직 단면」을 누릅니다."
        },
        {
          "title": "절단선 길이 넣기",
          "caption": "「수직 단면」 창입니다. 절단 위치(시작점에서 거리)는 가운데로 들어가 있습니다. 「절단선 길이(m)」를 8 m 로 바꿉니다."
        },
        {
          "title": "「확인」 누르기",
          "caption": "「확인」을 누릅니다."
        },
        {
          "title": "단면 그래프 보기",
          "caption": "절단선이 그려지고 카메라가 그 위로 옮겨 가며, 아래에 단면 그래프가 열립니다. 모델 단면 위에 원기둥 단면이 함께 그려져 계획 관로와 실제 배관 자리를 비교합니다."
        }
      ]
    },
    "t-members": {
      "title": "접속자와 금지구역",
      "steps": [
        {
          "title": "「박지호」 행 누르기",
          "caption": "작업현황 화면입니다. 「MEMBERS」(접속자) 패널에 프로젝트 참여자가 있고, 지도에는 모바일 앱에서 위치를 보내는 사람이 핀으로 보입니다. 「박지호」 행을 누릅니다."
        },
        {
          "title": "카드 확인",
          "caption": "지도가 박지호 자리로 옮겨 가고 카드가 열립니다. 역할, 최종 위치 보고, GPS 정확도, 위반 상태(지금은 「정상」)가 나옵니다."
        },
        {
          "title": "「ZONES」 누르기",
          "caption": "박지호가 있는 굴착부를 금지구역으로 정해 봅니다. 왼쪽 레일의 「ZONES」를 누릅니다."
        },
        {
          "title": "「새 금지구역 그리기」 누르기",
          "caption": "「금지구역 관리」입니다. 구역마다 켜고 끄는 스위치가 있고, ⋯ 메뉴에서 이름을 바꾸거나 지웁니다. 「새 금지구역 그리기」를 누릅니다."
        },
        {
          "title": "첫 꼭짓점 찍기",
          "caption": "그리기 안내가 뜹니다. 굴착부 둘레에 첫 꼭짓점을 찍습니다."
        },
        {
          "title": "두 번째 꼭짓점 찍기",
          "caption": "두 번째 꼭짓점을 찍습니다."
        },
        {
          "title": "세 번째 꼭짓점 찍기",
          "caption": "세 번째 꼭짓점을 찍습니다."
        },
        {
          "title": "마지막 꼭짓점 더블클릭",
          "caption": "마지막 꼭짓점은 더블클릭으로 찍어 그리기를 끝냅니다."
        },
        {
          "title": "구역 이름 넣기",
          "caption": "「새 금지구역 이름」 창이 열립니다. 구역 이름을 넣습니다."
        },
        {
          "title": "「확인」 누르기",
          "caption": "「확인」을 누릅니다."
        },
        {
          "title": "위반 알림 확인",
          "caption": "구역이 만들어지고, 그 안에 있는 박지호에 대해 「박지호 — 굴착부 출입 금지 금지구역 위반」 알림이 뜹니다."
        },
        {
          "title": "새 구역 확인",
          "caption": "목록에 구역이 더해지고 지도에 그려집니다. 박지호의 핀이 구역 안에 있습니다."
        },
        {
          "title": "「MEMBERS」 누르기",
          "caption": "접속자 목록에서도 확인합니다. 「MEMBERS」를 누릅니다."
        },
        {
          "title": "빨간 행 확인",
          "caption": "박지호 행이 빨갛게 바뀌고 「위반」과 구역 이름이 붙습니다. 열려 있는 카드의 위반 상태도 「위반 · 굴착부 출입 금지」로 바뀝니다."
        }
      ]
    },
    "t-equip": {
      "title": "장비·시설 배치",
      "note": "목록의 눈 아이콘으로 지도에서 숨긴 장비는 작업반경 겹침(위험)을 세지 않습니다.",
      "steps": [
        {
          "title": "「EQUIP」 누르기",
          "caption": "작업현황 화면 왼쪽 레일의 「EQUIP」을 누릅니다."
        },
        {
          "title": "「장비·시설 추가」 누르기",
          "caption": "「장비·시설」 패널에 놓아 둔 장비가 보입니다. 「장비·시설 추가」를 누릅니다."
        },
        {
          "title": "「굴삭기」 고르기",
          "caption": "지도 위에 분류(양중·고소, 토공·운반, 가설, 자재, 인력)와 종류 카드가 열립니다. 「굴삭기」를 누릅니다."
        },
        {
          "title": "규격 정하고 「배치」 누르기",
          "caption": "배치 창에서 이름, 기준 규격, 전장·전폭·전고·작업반경, 반경 색상을 정하고 「배치」를 누릅니다."
        },
        {
          "title": "놓을 자리 누르기",
          "caption": "종류 카드가 흐려지고 배치 상태가 됩니다. 지도에서 굴삭기 1 옆을 누릅니다. 우클릭하면 취소됩니다."
        },
        {
          "title": "겹친 작업반경 확인",
          "caption": "굴삭기 2가 놓입니다. 두 굴삭기의 작업반경이 겹친 곳이 빨갛게 칠해지고, 목록의 두 행에 위험 표시(!)가 붙습니다."
        },
        {
          "title": "「굴삭기 2」 펼치기",
          "caption": "겹치지 않게 옮겨 봅니다. 「굴삭기 2」 행 왼쪽의 펼치기 단추를 누릅니다."
        },
        {
          "title": "「위치·방향」 탭 누르기",
          "caption": "「규격」·「위치·방향」·「동선」 탭이 있습니다. 「위치·방향」을 누릅니다."
        },
        {
          "title": "「지도에서 옮기기」 누르기",
          "caption": "바라보는 방향 다이얼과 경도·위도·높이가 보입니다. 「지도에서 옮기기」를 누릅니다."
        },
        {
          "title": "새 자리 누르기",
          "caption": "단추가 「옮기는 중」으로 바뀝니다. 지도에서 겹치지 않는 자리를 누릅니다."
        },
        {
          "title": "옮긴 자리 확인",
          "caption": "굴삭기 2가 그 자리로 옮겨지고 경도·위도가 바뀝니다. 작업반경이 겹치지 않아 위험 표시가 사라집니다."
        }
      ]
    },
    "t-route": {
      "title": "장비 동선 시뮬레이션",
      "note": "재생하며 바뀌는 겹침은 지도에만 보이고, 목록의 위험 표시는 저장한 자리를 기준으로 셉니다.",
      "steps": [
        {
          "title": "「굴삭기 1」 펼치기",
          "caption": "「장비·시설」 패널입니다. 굴삭기 2에는 이미 동선이 있습니다. 「굴삭기 1」 행 왼쪽의 펼치기 단추를 누릅니다."
        },
        {
          "title": "「동선」 탭 누르기",
          "caption": "「동선」 탭을 누릅니다."
        },
        {
          "title": "「동선 그리기」 누르기",
          "caption": "「아직 동선이 없습니다」가 보입니다. 「동선 그리기」를 누릅니다."
        },
        {
          "title": "다음 점 찍기",
          "caption": "장비 자리가 첫 지점이 됩니다(「지점」 1). 지도에서 다음 점을 누릅니다."
        },
        {
          "title": "마지막 점 더블클릭",
          "caption": "마지막 점은 더블클릭으로 찍어 끝냅니다."
        },
        {
          "title": "「동선 재생」 누르기",
          "caption": "동선이 저장되고 「동선 시뮬레이션」에 재생 막대·반복·속도와 지점·거리·예상 시간이 나옵니다. 재생 단추를 누릅니다."
        },
        {
          "title": "「굴삭기 2」 펼치기",
          "caption": "굴삭기 1이 동선을 따라 움직입니다. 함께 움직여 보려고 「굴삭기 2」 행을 펼칩니다."
        },
        {
          "title": "「동선」 탭 누르기",
          "caption": "굴삭기 2의 「동선」 탭을 누릅니다."
        },
        {
          "title": "「동선 재생」 누르기",
          "caption": "굴삭기 2의 재생 단추를 누릅니다."
        },
        {
          "title": "겹치는 순간 확인",
          "caption": "두 굴삭기가 함께 움직이다 작업반경이 겹치면 겹친 곳이 빨갛게 칠해지고 이름표에 위험 표시(!)가 붙습니다."
        }
      ]
    },
    "t-ewzone": {
      "title": "3D 구역 토공량",
      "note": "물량은 구역 안 모든 셀에서 산출하고, 「계산 방식」의 단면도는 그 계산을 보여 주는 예시 구간입니다.",
      "steps": [
        {
          "title": "「＋ 구역 그리기」 누르기",
          "caption": "토공 화면입니다. 「3D 복셀」은 3D 모델 위에 그린 구역에 걸친 도면을 모두 합산해 토공량을 산출합니다. 「＋ 구역 그리기」를 누릅니다."
        },
        {
          "title": "첫 꼭짓점 찍기",
          "caption": "패널에 「구역을 그리는 중입니다. 더블클릭하면 그리기가 완료됩니다.」가 뜹니다. 굴착부 둘레에 첫 꼭짓점을 찍습니다."
        },
        {
          "title": "두 번째 꼭짓점 찍기",
          "caption": "두 번째 꼭짓점을 찍습니다."
        },
        {
          "title": "세 번째 꼭짓점 찍기",
          "caption": "세 번째 꼭짓점을 찍습니다."
        },
        {
          "title": "마지막 꼭짓점 더블클릭",
          "caption": "마지막 꼭짓점은 더블클릭으로 찍어 그리기를 끝냅니다."
        },
        {
          "title": "「계산하기」 누르기",
          "caption": "「구역 1」로 저장되어 목록에 더해지고 모델 위에 칠해집니다. 「구역 1에 사용된 도면」에 구역에 걸친 도면이 나옵니다. 「토공량」 카드의 「계산하기」를 누릅니다."
        },
        {
          "title": "「산출된 시계열 목록」 펼치기",
          "caption": "계산이 끝나 커버리지와 「계산 방식」·「토공 집계표 보기」가 생깁니다. 「산출된 시계열 목록 2/2」를 펼칩니다."
        },
        {
          "title": "「2024-01-25」 체크 풀기",
          "caption": "산출에 들어간 시계열이 나옵니다. 01-25는 굴착부를 다시 메운 뒤라 산출에서 빼 봅니다. 「2024-01-25」의 체크를 풉니다."
        },
        {
          "title": "「다시 계산」 누르기",
          "caption": "「산출에서 제외했습니다」가 붙고, 산출에 포함되는 시계열이 바뀌었다는 안내와 「다시 계산」이 나옵니다. 「다시 계산」을 누릅니다."
        },
        {
          "title": "「계산 방식」 누르기",
          "caption": "목록이 「1/2」로 바뀌고 안내가 사라집니다. 「계산 방식」을 누릅니다."
        },
        {
          "title": "창 안을 아래로 굴리기",
          "caption": "「계산 방식」 창입니다. 예시 구간 단면도로 셀마다 두 면의 차이를 세는 방식과 계획(원지반고→계획고) 물량을 보여 줍니다. 창 안을 아래로 굴립니다."
        },
        {
          "title": "기성·잔여 확인",
          "caption": "시계열마다 기성(원지반고→드론 지반고)과 잔여(드론 지반고→계획고) 단면도와 진행률이 나옵니다. 계획 = 기성 + 잔여입니다."
        }
      ]
    },
    "t-ewtable": {
      "title": "토공 집계표",
      "note": "구역이 여러 개면 구역마다 표가 생깁니다. 표를 끌어 순서를 바꾸고, 「CSV 내보내기에 포함」으로 파일에 담을 구역을 고릅니다.",
      "steps": [
        {
          "title": "「토공 집계표 보기」 누르기",
          "caption": "구역 1이 골라져 있습니다. 「토공량」 카드의 「토공 집계표 보기」를 누릅니다."
        },
        {
          "title": "「투명도」 막대 끌기",
          "caption": "「토공 집계표」 창입니다. 흙깎기(토사)와 흙쌓기(노상·노체)를 계획 수량·잔여토공량·일자별 누계와 촬영일별 진행 물량으로 보여 줍니다. 「투명도」 막대를 오른쪽으로 끕니다."
        },
        {
          "title": "표 아래 모델 보기",
          "caption": "표가 비쳐 아래의 3D 모델과 구역이 함께 보입니다. 창 머리를 끌어 옮길 수 있고, 「CSV 내보내기 (구역 1개)」로 표를 파일로 받습니다."
        }
      ]
    },
    "t-linear": {
      "title": "선형 기반 토공",
      "note": "단면 설정·그래프·횡단 수량표는 <a href=\"#c6\">06 단면 그래프</a>와 같습니다.",
      "steps": [
        {
          "title": "「선형 기반」 누르기",
          "caption": "「선형 기반」은 선형 하나로 측점마다 단면과 수량을 봅니다. 토공 패널 위쪽의 「선형 기반」을 누릅니다."
        },
        {
          "title": "「단면 그래프 열기」 누르기",
          "caption": "선형 레이어 목록과 단면·수량표를 어느 시계열의 현황면으로 산출하는지가 나옵니다. 행의 그래프 아이콘(「단면 그래프 열기」)을 누릅니다."
        },
        {
          "title": "「횡단면」 「확인」 누르기",
          "caption": "모델 위에 노선과 측점이 표시되고 단면 설정 패널이 열립니다. 「횡단면」의 「확인」을 누릅니다."
        },
        {
          "title": "노선을 가운데로 끌기",
          "caption": "측점마다 횡단면 선이 그려지고 첫 측점의 횡단면 그래프가 아래에 열립니다. 노선이 그래프에 가리지 않게 왼쪽 버튼으로 끌어 가운데로 옮깁니다."
        },
        {
          "title": "오른쪽 버튼으로 기울이기",
          "caption": "바로 내려다보는 화면입니다. 오른쪽 버튼을 누른 채 위로 끌어 모델을 기울입니다."
        },
        {
          "title": "0+060 횡단면 선 누르기",
          "caption": "모델을 비스듬히 봅니다. 모델 위 0+060 횡단면 선을 누릅니다."
        },
        {
          "title": "「더보기」 누르기",
          "caption": "그래프가 그 측점(060)의 횡단면으로 바뀝니다. 「더보기」를 누릅니다."
        },
        {
          "title": "「수량표」 누르기",
          "caption": "「수량표」를 누릅니다."
        },
        {
          "title": "수량표 보기",
          "caption": "「횡단 수량표」 창입니다. 이 측점의 원지반고·계획고·현황고와 쌓기·깎기 면적을 계획(파랑)·진행(초록)으로 보여 줍니다."
        }
      ]
    },

  },
  "mapping": {
    "gcpPath": "GCP(지상 기준점)를 쓰면 위치 정확도가 올라갑니다. $t(projects:timeSeries.mappingInfo)의 GCP 행에서 GCP 파일($t(projects:timeSeries.gcpGuide.readableFormats))을 올린 뒤 매핑을 요청하세요.",
    "autoDetect": "GCP 행에 [$t(projects:timeSeries.gcpAutoDetect)]이 보이면, 드론스퀘어 표준 표식을 깔고 촬영한 회차는 사람 손 없이 자동으로 매핑됩니다. 표식은 촬영 전에 준비해야 하니 아래 가이드를 먼저 확인하세요.",
    "ownerOnly": "매핑 요청은 프로젝트 소유자만 할 수 있습니다.",
    "processingTime": "처리 시간은 사진 수와 처리 방식(자동·담당자)에 따라 다릅니다."
  }
} as const;

export default landingManual;
